module.exports = __webpack_public_path__ + "static/media/bema.efc9a150.png";